import React,{Component} from 'react';
import { formatNumberByComma, createUrl } from '../../../common/utils'

export const Combiner = ({loginBox,swiperBox,children})=>{
    return <div>
        {loginBox}
        <div className="np-main">
            <div className="np-buy-box">
                {swiperBox}
                <div className="np-buy-main">
                    {children}
                </div>
            </div>
        </div>
    </div>
}

export const TotalPriceBox = ({totalPrice})=>{
    return <div className="np-buy-sum">
        <p>合计：<em>{formatNumberByComma(totalPrice)}</em>元</p>
    </div>
}
export const PromiseBox = ()=>{
    return <div className="np-buy-promise">
        <i className="i-promise"></i>15天质量问题换货&nbsp;&nbsp;&nbsp;&nbsp;
        <i className="i-promise"></i>365天保修
    </div>
}

export const PriceBox = ({price, counts})=>{
    const {orange,black,blue} = counts;
    const greaterThanZero = (orange+black+blue)>0 ? true : false;
    return <div className="np-buy-text">
        <h2>玩客云 畅快下载的私人云盘</h2>        
        <p>【企业用户限时特惠】一次性下单满50台每台328元！</p>
        {greaterThanZero ? <div className="np-buy-price">限时优惠：<em><span>{price}</span>元</em><del>599元</del></div> : <div className="np-buy-price">官方指导价：<em><span>599元</span></em></div>}
        {/* <div className="np-buy-seckill">限时秒杀<em>18:00即将开始</em></div>
        <div className="np-buy-seckill np-buy-seckill-over">限时秒杀<em>活动已结束</em></div>
        <div className="np-buy-seckill">限时秒杀<em>剩3天12小时23分3秒</em></div> */}
    </div>
}

export const BuyButton = ({isLogin,totalPrice,submit})=>{
    return <div className="np-buy-btn">
        {(isLogin&&totalPrice)? 
            <a className="btn-np" href="javascript:;" onClick={submit}>立即下单</a> 
            :<a className="btn-np btn-np-disable" href="javascript:;">立即下单</a>
        }
    </div>
}


// WEBPACK FOOTER //
// ./js/src/pages/Purchase/components/stateless.jsx